// extracted by mini-css-extract-plugin
export default {"wrapper":"Self_wrapper__+eE3O","card":"Self_card__eMa74","cardDesc":"Self_cardDesc__+aCaE","active":"Self_active__bkMsY","input":"Self_input__KjzeN","input2":"Self_input2__VLhcs"};